export enum OverlayStatus {
  Loading = 'Loading',
  Initial = 'Initial',
  TimedOut = 'TimedOut',
  FaceDetected = 'FaceDetected',
  Complete = 'Complete',
}
